// Do-not-disturb flag the push service worker can read (CU-869fmcc9r).
// A service worker cannot see localStorage, so the page mirrors the pill's
// DND toggle into the Cache API; public/firebase-messaging-sw.js reads the
// same cache name and key. Keep the three constants in sync with that file.

export const CALL_PREFS_CACHE = 'dentalsem-call-prefs';
export const callDndKey = (userId) => `/__call-prefs/dnd/${userId}`;

// Resolves true when written, false when unavailable or failed. Never throws.
export async function writeCallPushDnd(userId, on) {
  try {
    if (userId === null || userId === undefined || userId === '') return false;
    if (typeof caches === 'undefined' || !caches?.open) return false;
    const cache = await caches.open(CALL_PREFS_CACHE);
    await cache.put(callDndKey(userId), new Response(on ? '1' : '0'));
    return true;
  } catch {
    return false;
  }
}

export default writeCallPushDnd;
